
<div id="switch" class="checkbox checbox-switch switch-primary position-relative" [style.height.px]="labelchild.offsetWidth">
  <label #labelchild class="position-absolute">
    <input [id]="input.MainElementList[0].ID" type="checkbox" [checked]="input.MainElementList[0].Value === '0'? false : true" (change)="checkChange($event, input)" />
    <span></span>
  </label>
</div>

<div *ngIf="input.MainElementList[0].Value !== '0'" class="q-select" [ngClass]="{'input-disabled':input.MainElementList[1].Disabled}">
  <select [id]="input.MainElementList[1].ID" class="q-main-select" (change)="selectChange($event.target.value)">
    <option *ngFor="let option of input.MainElementList[1].SelectOptionsList; let i = index" [value]="option.Value" [selected]="option.Selected">{{option.Text}}</option>
  </select>
</div>

<!--[require]="input.MainElementList[1].Required" [disabled]="input.MainElementList[1].Disabled" [mode]="'bo'"-->
